import rootUrl from "../url";

export default rootUrl + "api/members/";
